import cx from "classnames";

function Card({
  children,
  padding = true,
  className = "",
  style = {},
  onClick = (e) => {},
}) {
  return (
    <div
      onClick={onClick}
      style={style}
      className={cx("Card rounded bg-background shadow " + className, {
        "p-4": padding,
      })}>
      {children}
    </div>
  );
}

export { Card };
